<div class="container-fluid d-flex align-items-center justify-content-center op-home-container">
  <div class="home-card card shadow d-flex flex-column w-100">
    <div class="card-header">
      <h5 class="mb-0">Shared Planograms</h5>
    </div>

    <div class="card-body flex-grow-1 p-0 justify-content-center align-items-center">
      @if (isLoading) {
        <div class="loading-container d-flex flex-column align-items-center justify-content-center h-100">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-muted">Loading shared planograms...</p>
        </div>
      } @else {
        @if (planograms.length > 0) {
          <div class="planogram-list list-group list-group-flush scrollable-list">
            @for (planogram of planograms; track planogram) {
              <div class="list-group-item d-flex justify-content-between align-items-start py-3">
                <div>
                  <div class="fw-medium">
                    {{ getLatestState(planogram)?.name || "Unnamed Planogram" }}
                  </div>
                  <small class="text-muted">Store: {{ planogram.storeName }} | Merch: {{ planogram.merchName }}</small><br />
                  <small class="text-muted">Created: {{ planogram.dateCreated | date:"MMM d, y, h:mm a" }}</small><br />
                  <small class="text-muted">Last Edited: {{ planogram.dateLastEdited | date:"MMM d, y, h:mm a" }}</small><br />
                  <div class="d-flex gap-2">
                    <small class="badge bg-primary">Shared By: {{ planogram.share?.sharedBy }}</small>
                    <small class="badge bg-secondary">Shared: {{ planogram.share?.type === 0 ? 'View' : 'Edit' }}</small>
                  </div>
                </div>
                <button class="btn btn-outline-primary" (click)="openPlanogram(planogram)">Open</button>
              </div>
            }
          </div>
        } @else {
          <div class="text-center text-muted mt-5">
            <i class="bi bi-folder-x fs-1"></i>
            <p class="mt-2">No shared planograms available.</p>
          </div>
        }
      }
    </div>
  </div>
</div>